import React from 'react'
import { TableRow, TableRowProps } from '@/ui/atoms/Table/TableRow'

export type TableProps = {
  rows: TableRowProps[]
  className?: string
}

export const Table: React.FC<TableProps> = ({ rows, className }) => {
  return (
    <div className={`flex flex-col gap-0 rounded-md overflow-hidden ${className || ''}`}>
      {rows.map((row, index) => (
        <TableRow key={`table-row-${index}`} {...row} />
      ))}
    </div>
  )
}
